import React, { Component } from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import history from '../history';
import { logoutAction } from '../modules/logins/actions/LoginActions';
import { logoutAction as clientLogoutAction } from '../modules/PatientPortal/logins/actions/LoginActions';
import { logoutAction as superadminLogoutAction } from '../modules/Superadmin/logins/actions/LoginActions';
import { connect } from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import ChangePasswordModal from './changePasswordModal';
import ChangeSuperadminPasswordModal from './changeSuperadminPasswordModal';
import UpdatePasswordModal from './updatePasswordModal';
injectTapEventPlugin();


class AvatarDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openSuperadmin: false,
      showUpdatePasswordModal: false,
    };
  }
  state = {
    valueSingle: '3',
    valueMultiple: ['3', '5'],
  };

  handleOnRequestChange = (value) => {
    this.setState({
      openMenu: value,
    });
  }

  logout(e) {
    e.preventDefault();
    this.props.logoutAction();
  }

  clientlogout(e) {
    e.preventDefault();
    this.props.clientLogoutAction();
  }
  superadminlogout(e) {
    e.preventDefault();
    this.props.superadminLogoutAction();
  }


  handleUserProfileClick = () => {
    if (this.props.loginUserInfo.id !== '') {
      history.push(`/user-profile/${this.props.loginUserInfo.id}`);
    }
  };

  handleConfigClick = () => {
    history.push('/app-config/');
  };

  handleChangePassword = () => {
    this.setState({
      open: true,
      openMenu: false,
    });
  }

  handleSuperadminChangePassword = () => {
    this.setState({
      openSuperadmin: true,
      openMenu: false,
    });
  }
  

  handleClose = () => {
    this.setState({ open: false, openSuperadmin: false });
  };

  componentDidUpdate(prevProps){
    if(prevProps.password !== this.props.password){
      if(this.props.password && this.props.password.statusCode >= 200 && 
        this.props.password.statusCode < 300 && 
        this.props.password.statusCode !== 204){
          this.setState({ showUpdatePasswordModal: true });
        }
    }
  }

  render() {
    const style = {
      zIndex: '1500',
    };

    let { userImage, welcomeNote } = this.props;
    return (
      <div>
        <IconMenu
          style={style}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          iconButtonElement={<IconButton>
            <Avatar
              src={userImage}
              size={35}
            />
          </IconButton>}
          open={this.state.openMenu}
          onRequestChange={this.handleOnRequestChange}>
          {this.props.loginUserInfo && this.props.loginUserInfo.users3 ?
            this.props.loginUserInfo.users3.userRoles.roleName === 'Client' ?
              <span>
                <MenuItem onClick={this.handleChangePassword} primaryText="Change Password" leftIcon={<i className="material-icons">vpn_key</i>} />
                <Divider />
                <MenuItem onClick={(e) => this.clientlogout(e)} primaryText="Sign Out" leftIcon={<i className="material-icons">power_settings_new</i>} />
              </span>
              :
              (this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'ADMIN' ? <span>
                <div className="sm-welcomename">{welcomeNote}</div>
                {/* <MenuItem className="sm-welcomename" primaryText={welcomeNote} leftIcon={<i className="material-icons">person</i>} />*/}
                <MenuItem onClick={this.handleConfigClick} primaryText="Settings" leftIcon={<i className="material-icons">settings</i>} />
                <MenuItem onClick={this.handleChangePassword} primaryText="Change Password" leftIcon={<i className="material-icons">vpn_key</i>} />
                {/* <MenuItem primaryText="Help" leftIcon={<i className="material-icons">help_outline</i>} /> */}
                <Divider />
                <MenuItem onClick={(e) => this.logout(e)} primaryText="Sign Out" leftIcon={<i className="material-icons">power_settings_new</i>} />
              </span> : <span>
                  {this.props.lockScheduleUptoSpecifiedDate || this.props.modifySignatureRequirementsOnSessionNotesPermission ? 
                    <MenuItem onClick={this.handleConfigClick} primaryText="Settings" leftIcon={<i className="material-icons">settings</i>} />
                  :null}
                  <MenuItem onClick={this.handleChangePassword} primaryText="Change Password" leftIcon={<i className="material-icons">vpn_key</i>} />
                  <Divider />
                  <MenuItem onClick={(e) => this.logout(e)} primaryText="Sign Out" leftIcon={<i className="material-icons">power_settings_new</i>} />
                </span>)
            :
            this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERADMIN' ?
              <span>
                <MenuItem onClick={(e) => this.superadminlogout(e)} primaryText="Sign Out" leftIcon={<i className="material-icons">power_settings_new</i>} />
              </span>
              : 
              this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERUSER'  ?
                <span>
                  <MenuItem onClick={this.handleSuperadminChangePassword} primaryText="Change Password" leftIcon={<i className="material-icons">vpn_key</i>} />
                  <Divider />
                  <MenuItem onClick={(e) => this.superadminlogout(e)} primaryText="Sign Out" leftIcon={<i className="material-icons">power_settings_new</i>} />
                </span> : ''
          }
        </IconMenu>
        {this.state.open ? <ChangePasswordModal closeDialog={this.handleClose}/> : ''}
        {this.state.showUpdatePasswordModal && <UpdatePasswordModal/> }
        {this.state.openSuperadmin ? <ChangeSuperadminPasswordModal closeDialog={this.handleClose} /> : ''}
      </div>

    );
  }
}
const mapStateToProps = (state) => {

  // Start For Role Permission
  let dashboardScreenPermission = [];
  let userActionPermission = [];  
  if (state.login.userPermission) {
    let dashboardModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'DASHBOARD');
    dashboardScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === dashboardModulePermission[0].moduleId);
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3 && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  //let lockScheduleUptoSpecifiedDate = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0].permission : false;
  let lockScheduleUptoSpecifiedDate = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0].permission : false;

  let modifySignatureRequirementsOnSessionNotesPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_MODIFY_SIGNATURE_REQUIREMENTS_ON_SESSION_NOTES_UNDER_SETTINGS')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_MODIFY_SIGNATURE_REQUIREMENTS_ON_SESSION_NOTES_UNDER_SETTINGS')[0].permission : false;

  // End For Role Permission

  return {
    loginUserInfo: state.login.loginUserInfo,
    lockScheduleUptoSpecifiedDate: lockScheduleUptoSpecifiedDate,
    modifySignatureRequirementsOnSessionNotesPermission: modifySignatureRequirementsOnSessionNotesPermission,
    password : state.changePassword.changePasswordData,
  };
};

export default connect(mapStateToProps, { logoutAction, clientLogoutAction, superadminLogoutAction })(AvatarDropdown);



// WEBPACK FOOTER //
// ./src/components/avatarDropdown.js